/**
 * Pay-flow active lock — mirrors apps/mobile/lib/pay-flow.ts.
 * Locked while the user is in the pay flow; PersonaSwitcher reads
 * this to disable switching during payment processing.
 */
import { create } from "zustand";

interface PayFlowState {
  active: boolean;
  lock: () => void;
  unlock: () => void;
}

export const usePayFlowStore = create<PayFlowState>()((set) => ({
  active: false,
  lock: () => set({ active: true }),
  unlock: () => set({ active: false }),
}));
